import React from 'react';
import styles from '../styles.module.scss';

type Props = {
  leftSide: React.ReactNode;
  rightSide: React.ReactNode;
};

const ConsultationDesktopLayout = ({ leftSide, rightSide }: Props): JSX.Element => {
  return (
    <>
      <div className={styles.consultationPageLeftSide}>{leftSide}</div>
      <div className={styles.consultationPageRightSide}>{rightSide}</div>
    </>
  );
};

export default ConsultationDesktopLayout;
